
import { connect } from "react-redux";
import { NewAccount } from "./new-account";
import { dataToStore, clearOnboardingData } from "../../onboarding/actions";
import { navigatePath } from "../../nav/actions";
import { onboardingLogin } from "../login/actions";
import { dwollaUpdate } from "../../payment/actions";
import { tdaUpdate } from "../../tda/actions";
import {toggleHyperverge} from "../../app/actions";

const mapDispatchToProps = dispatch => {
  return {
    dataToStore: (data, index) => { dispatch(dataToStore(data, index)) },
    clearOnboardingData: () => { dispatch(clearOnboardingData()) },
    navigatePath: (path, args) => { dispatch(navigatePath(path, args))},
    onboardingLogin: (name, id, account_type, onboarding_token, token, identity_id) => {
      dispatch(onboardingLogin(name, id, account_type, onboarding_token, token, identity_id))
    },
    dwollaUpdate: (data, index) => { dispatch(dwollaUpdate(data, index))},
    tdaUpdate: (data, index) => { dispatch(tdaUpdate(data, index))},
    toggleHyperverge: () => { dispatch(toggleHyperverge()) },
  }
};

const mapStateToProps = state => {
  return {
    client: state.client,
    wlf_id: state.app.wlf && state.app.wlf.id,
    has_onboarding: !!(state.user.onboarding_token),
    logged_in: !!(state.user.token),
    config: state.app.config,
    app: state.app,
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(NewAccount);
